// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 2L13 22H11L11 2L13 2ZM2 5L9 5L9 19H2L2 5ZM15 5L22 5V19H15L15 5Z"}}]};

const ComponentDividerHorizontalFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-divider-horizontal-filled',
    ref,
    icon: element,
  },
));

ComponentDividerHorizontalFilledIcon.displayName = 'ComponentDividerHorizontalFilledIcon';

export default ComponentDividerHorizontalFilledIcon;
